import React from 'react';
import {
  Box,
  BoxProps,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react';
import { ImInfo } from 'react-icons/im';

type InfoPopoverProps = React.PropsWithChildren<{
  triggerContainerProps?: BoxProps;
  infoIconProps?: BoxProps & { 'data-testid': string };
  popoverContentProps?: PopoverContentProps & { 'data-testid'?: string };
}>;

export function InfoPopover({ triggerContainerProps, popoverContentProps, infoIconProps, children }: InfoPopoverProps) {
  return (
    <Popover isLazy trigger={'hover'}>
      <PopoverTrigger>
        <Box
          onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
          {...triggerContainerProps}
          as="span"
        >
          <Box
            color="customBlue.500"
            display="inline"
            ml={1}
            mb={'-3px'}
            cursor={'pointer'}
            as={ImInfo}
            {...infoIconProps}
          />
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent maxWidth="400px" p={2} rounded={20} zIndex={4} {...popoverContentProps}>
          <PopoverArrow />
          <PopoverBody textAlign="center">{children}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
